import React from 'react';
import Adds from './add';
import Address from './address';
import ViewMachineDetails from './ViewMachineDetails';

class Title extends React.Component {

  state = {

  }

  render() {
    let i = 0;
    return (
      <div>
        <table id="table" width="100%">
          <tr>
            <td id="tableheader" style={{width: '5%'}}><center>Sino</center></td>
            <td id="tableheader" style={{width: '21%'}}><center>Name</center></td>
            <td id="tableheader" style={{width: '12%'}}><center>Mobile</center></td>
            <td id="tableheader" style={{width: '12%'}}><center>Alt Mobile</center></td>
            <td id="tableheader" style={{width: '11%'}}><center>Email</center></td>
            <td id="tableheader" style={{width: '11%'}}><center>View Machine</center></td>
            { this.props.menuPermission.edit ?
              <td id="tableheader" style={{width: '5%', display: this.props.machinecustomeredit}}>
                <center>Edit</center>
              </td>:''
            }
            
            <td id="tableheader" style={{width: '10%', display: this.props.machinecustomeredit}}>
              <center>Address</center>
            </td>
          </tr>
          { this.props.data.map((x) => {
              i++;
              return (
                <tbody>
                  <tr>
                    <td><center>{i}</center></td>
                    <td>{x.id+"->"+x.name}</td>
                    <td><div>{x.mobile}</div></td>
                    <td><div>{x.alt_mobile}</div></td>
                    <td><div>{x.email}</div></td>
                    <td><ViewMachineDetails item={x} /></td>
                    { this.props.menuPermission.edit ?
                      <td style={{cursor: 'pointer'}}>
                        <center>
                          <Adds getMachineCustomer={this.props.getMachineCustomer}
                                type='edit' data={this.props.data} id={x.id} />
                        </center>
                      </td>:''
                    }
                    <td style={{cursor: 'pointer'}}>
                      <center>
                        <Address menuPermission={this.props.menuPermission} cid={x.id} />
                      </center>
                    </td>
                  </tr>
                </tbody>
              )
            })
          }
        </table>
      </div>
    );
  }
}

export default Title;
